import { Button, Input, TitledMessage } from '@seddi/ui-kit';
import type { User } from 'firebase/auth';
import React, { useState } from 'react';
import * as S from './login.styles';
import brandLogo from './seddi_fitroom.svg';

interface LoginProps {
  signInWithEmail: (email: string, password: string) => Promise<User | undefined>;
}

export function Login({ signInWithEmail }: LoginProps): JSX.Element {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = async (): Promise<void> => {
    await signInWithEmail(email, password);
  };

  const onClick = async (e: React.MouseEvent<HTMLElement>): Promise<void> => {
    e.preventDefault();
    await onSubmit();
  };

  const brandLogoElement = (): JSX.Element => {
    return (
      <S.CommunicationPanelLogoArea>
        <img alt="Fitroom" src={brandLogo} />
      </S.CommunicationPanelLogoArea>
    );
  };

  return (
    <S.FormContainer>
      {brandLogoElement()}
      <TitledMessage title="Start your virtual try-on" titleAligned="center">
        Create an account or log in to get started
      </TitledMessage>
      <S.FieldsWrapper>
        <S.Form>
          <S.Field>
            <Input
              autoComplete="username"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
              placeholder="Email"
              type="email"
              value={email}
            />
            <Input
              autoComplete="current-password"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPassword(e.target.value);
              }}
              placeholder="Password"
              type="password"
              value={password}
            />
          </S.Field>
          <S.ActionWrapper>
            <Button
              isDisabled={!email || !password}
              onClick={(e: React.MouseEvent<HTMLElement>): void => {
                void onClick(e);
              }}
              text="Sign In"
              type="submit"
              variant="outlined"
              width="full"
            />
          </S.ActionWrapper>
        </S.Form>
      </S.FieldsWrapper>
    </S.FormContainer>
  );
}
